<template>
  <div v-html="message"></div>
  <br/>
  <div class="vueforms-dialog-buttons-bottom">
    <hy-button @click="resolve(false)">Schließen</hy-button>
  </div>
</template>

<script>
import HyButton from '../../basic-components/HyButton.vue';


export default {
  props: [ "resolve", "reject", "message"],
  inheritAttrs: false,
  components: {
    HyButton
  },
  setup(props){
    return {};  
  }
}
</script>

<style>

</style>